/* eslint-disable no-unused-vars */
import '@fortawesome/fontawesome-free/css/all.min.css';
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import getConfig from 'next/config';
// import * as Sentry from '@sentry/nextjs';
import Theme from 'components/layout/Theme';
import InactiveCustomerGuard from 'components/organisms/InactiveCustomerGuard';
import { VoucherDetailPopupProvider } from 'components-v3/organisms/VoucherDetailPopup';
import { MOBILE } from 'constants/Device';
import { ACCOUNT, CART_URL, CHECKOUT_URL, QUICK_ORDER } from 'constants/Paths';
import {
  AuthProvider,
  CartContextProvider,
  LoadingRoute,
  NotiContextProvider,
  ProductContextProvider,
  SearchProvider,
  SettingProvider,
  TicketProvider,
  WishListProvider,
} from 'context';
import ContextProviderComposer from 'context/ContextProviderComposer';
import App from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
// import '../scripts/wydr';
// Toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Theme
import { ThemeProvider as StyledTheme } from 'styled-components';
import { ENV, INSIDER_ID, INSIDER_SCRIPT_DOMAIN, WEB_HOST } from 'sysconfig';
import { ScrollToTop, gtag } from 'utils';
// CSS global
// import IconChat from 'components-v2/atoms/IconChat';
import {
  DEFAULT_THUOCSI_DESCRIPTION,
  DEFAULT_THUOCSI_LONG_TITLE,
  DEFAULT_THUOCSI_TITLE,
} from 'constants/data';
import { appWithTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import Script from 'next/script';
// import * as Services from 'services';
import { VISITED_URLS_STORAGE_KEY } from 'constants/data/cookies';
import { PopupProvider } from 'context/Popup';
import Clarity from 'third-party/Clarity';
import { changeDomainStorage } from 'utils/CacheImageUtils';
import fbpixel from 'utils/fbpixel';
import { GA_TRACKING_ID_V2 } from 'utils/gtag';
import { captureUtmLandingURL } from 'utils/registerURL';
import { GLOBAL_STORE } from 'zustand-lib';
import useMobileV2 from 'zustand-lib/storeMobile';
import useChat from 'zustand-lib/useChat';
import nextI18nConfig from '../../next-i18next.config';
import '../styles/globals.css';
import '../styles/icomoon.css';

// Happy lunar new year 2023
const IconChat = dynamic(() => import('components-v2/atoms/IconChat'), { ssr: false });
const ChatThuocSi = dynamic(() => import('utils/ChatThuocsi'), { ssr: false });

// Widget hỗ trợ nổi - chỉ chạy phía client, lazy-load để tách khỏi initial chunk của _app
const SupportCenter = dynamic(() => import('components-v2/organisms/SupportCenter'), {
  ssr: false,
});

const { publicRuntimeConfig } = getConfig();

const pathNoRedirect = [
  '/',
  '/list-product',
  '',
  '/flagship-store',
  '/flagship-store/[slug]/list-product',
  '/flagship-store/[slug]',
  '/flagship-store/durex',
  '/flagship-store/durex/list-product',
  '/flagship-store/durex/rewards',
  '/flagship-store/sanofi',
  '/flagship-store/sanofi/list-product',
  '/flagship-store/sanofi/rewards',
  '/phanhoi',
  '/qr',
  '/qr/[code]',
  'phanhoi',
  'feedback',
  '/feedback',
  '/flagship-store/[slug]/flagship-rewards',
  '/flagship-store/[slug]/rewards',
  '/tracking-order',
];

const DISABLE_INSIDER = ['tracuu.thuocsi.vn', 'phanhoi.thuocsi.vn'];
const CHAT_HIDE_URLS = ['/discovery', CART_URL, CHECKOUT_URL, ACCOUNT, QUICK_ORDER];

const MyApp = (props) => {
  const { Component, pageProps, host = '', buildId = '' } = props;

  const {
    user = {},
    accountInfo = {},
    SEO_CONFIG = {},
    initialZustandState = {},
    cartQuantity = [],
  } = pageProps || {};

  const { useCreateStore, Provider } = GLOBAL_STORE || {};

  // Sentry?.setTag('buildId', buildId);
  // Sentry.setUser({ id: user?.customerID });
  const {
    insiderSetting = false,
    thumbnailMap = {},
    defaultThumbnail = {},
  } = initialZustandState || {};

  const router = useRouter();
  const { query, replace, pathname } = router || {};
  const createStore = useCreateStore(pageProps.initialZustandState);
  const { referCode, action, login, forgetpasscode, t, token, redirectUrl } = query || {};
  const isShowingLogin = login === 'true';

  const isMobileV2 = useMobileV2((state) => state.isMobileV2());
  const isTrackingMobileV2 = useMobileV2((state) => state.isTrackingMobileV2);

  const { clearState } = useChat((state) => state);
  let isEnableInsider = insiderSetting;
  if (host) {
    isEnableInsider = !DISABLE_INSIDER.some((item) => item === host) && insiderSetting;
  }

  // Dùng SEO default là thông tin SEO của trang chủ
  const seoInfo = thumbnailMap[router.asPath] || {};
  const toggleChat = () => {
    clearState();
    router.push(`/conversations`);
  };

  // Generate canonical url
  // SEO: bỏ query string, để ?utm=..., ?fbclid=..., ?page=... không bị Google coi là bản trùng
  const canonicalUrl = WEB_HOST + (router?.asPath || '/').split(/[?#]/)[0];
  const canonicalUrlMobile = canonicalUrl;

  // hide page chat
  const isShowIconFBPage = !CHAT_HIDE_URLS.includes(pathname);

  // config https://material-ui.com/guides/server-rendering/
  useEffect(() => {
    // if (window) window.Services = Service;

    // initAllSellers();
    // Remove the server-side injected CSS.
    // if (!isPrd && window) {
    //   window.Services = Services;
    // }
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    // lỗi zalo
    // if (!window.zaloJSV2) {
    //   window.zaloJSV2 = {};
    // }

    // nếu khách vào thuocsi.com.vn -> cần redirect lại domain chính
    // if (window && window?.location?.href?.indexOf('thuocsi.com.vn') >= 0) {
    //   router.push(`${DOMAIN_WEB_HOST}`);
    // }

    // Prevent pull to refresh for chat mobile
    if (router.pathname === '/conversations') {
      document.querySelector('html')?.classList.add('preventPullToRefresh');
    } else {
      document.querySelector('html')?.classList?.remove('preventPullToRefresh');
    }
  }, []);

  const saveUrlWhenChangeRoute = () => {
    try {
      const visitedUrls = JSON.parse(localStorage.getItem(VISITED_URLS_STORAGE_KEY) || '[]');

      const currentUrl = window?.location?.href;
      if (currentUrl && currentUrl?.startsWith('http')) {
        let newVisitedUrls = currentUrl;

        if (visitedUrls[visitedUrls.length - 1] !== currentUrl) {
          newVisitedUrls = [...visitedUrls, currentUrl];
        }

        if (newVisitedUrls.length > 5) {
          // Chỉ lấy 5 urls gần nhất
          newVisitedUrls = newVisitedUrls.slice(newVisitedUrls.length - 5, newVisitedUrls.length);
        }

        localStorage.setItem(VISITED_URLS_STORAGE_KEY, JSON.stringify(newVisitedUrls));
      }
    } catch (e) {
      localStorage.setItem(VISITED_URLS_STORAGE_KEY, '[]');
    }
  };

  // DOMAINS_THUOCSI -> domain thuocsi sẽ chạy, các host khác proxy tới thuocsi sẽ bị đá lại domain chính
  // useEffect(() => {
  // nếu chuyển sang trang products ... thì sẽ check host , nếu ko đúng host thì tự redirect sang domain chính
  // if (DOMAINS_THUOCSI?.indexOf(host) === -1 && !pathNoRedirect.includes(router.pathname)) {
  //   router.push(`${DOMAIN_WEB_HOST}${router.asPath}`);
  // }

  // TODO:   nếu user là miền bắc -> hk.thuocsi.vn , nếu user là miền nam ->thuocsi.vn
  // internet bị đứt nên cần move uat / prd sang hk.thuocsi.vn
  // NG dùng miền bắc - sài domain thuocsi.vn -> thì vào hk

  // off redirect -> hk  06Mar2023
  // if (['prd'].includes(ENV) && user && regionsMB && regionsMB?.includes(`${user.provinceCode}`) && host?.startsWith('thuocsi.vn')) {
  //   // test
  //   // if (user && regionsMB && regionsMB?.includes(`${user.provinceCode}`) && host !== 'hk.thuocsi.vn') {
  //   // redirect to hk / nếu là khách miền abwcs
  //   router.push(`https://hk.thuocsi.vn/${router.asPath}`);
  // }
  // }, [router.asPath]);

  useEffect(() => {
    const handleRouteChange = async (url) => {
      gtag.pageview(url, user);
      // save router change
      saveUrlWhenChangeRoute();
      fbpixel.pageview();
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  // Lead tracking: lưu URL có UTM gần nhất ("last click") để gửi registerURL khi đăng ký
  useEffect(() => {
    captureUtmLandingURL();
    router.events.on('routeChangeComplete', captureUtmLandingURL);
    return () => {
      router.events.off('routeChangeComplete', captureUtmLandingURL);
    };
  }, [router.events]);
  const LinkBanner = `${WEB_HOST}/logo_banner.png`;
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta httpEquiv="Cache-Control" content="no-cache" />
        <meta httpEquiv="Expires" content="-1" />
        <meta name="keywords" content="buymed" />
        <title>
          {seoInfo?.pageTitle ||
            SEO_CONFIG?.title ||
            defaultThumbnail?.pageTitle ||
            DEFAULT_THUOCSI_LONG_TITLE}
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"
        />
        <link rel="canonical" href={canonicalUrl} />
        <link
          rel="alternate"
          media="only screen and (max-width: 640px)"
          href={canonicalUrlMobile}
        />
        <meta
          property="title"
          content={
            seoInfo?.title || SEO_CONFIG?.title || defaultThumbnail?.title || DEFAULT_THUOCSI_TITLE
          }
        />
        <meta
          property="description"
          content={
            seoInfo?.description ||
            SEO_CONFIG?.description ||
            defaultThumbnail?.description ||
            DEFAULT_THUOCSI_DESCRIPTION
          }
        />
        <meta
          property="og:title"
          content={
            seoInfo?.title ||
            SEO_CONFIG?.ogTitle ||
            defaultThumbnail?.title ||
            DEFAULT_THUOCSI_TITLE
          }
        />
        <meta
          property="og:image"
          content={changeDomainStorage(
            seoInfo?.imageUrl || SEO_CONFIG?.ogImage || defaultThumbnail?.imageUrl || LinkBanner,
          )}
        />
        <meta
          property="og:image:alt"
          content={
            seoInfo?.title ||
            SEO_CONFIG?.ogImageAlt ||
            defaultThumbnail?.title ||
            DEFAULT_THUOCSI_LONG_TITLE
          }
        />
        <meta
          property="og:description"
          content={
            seoInfo?.description ||
            SEO_CONFIG?.ogDescription ||
            defaultThumbnail?.description ||
            DEFAULT_THUOCSI_DESCRIPTION
          }
        />
        <link rel="manifest" href="/manifest.json" />
      </Head>
      {/* <NextNprogress color="#29D" startPosition={0.3} stopDelayMs={200} height="3" options={{ showSpinner: false }} /> */}
      <StylesProvider injectFirst>
        <StyledTheme theme={Theme}>
          <MuiThemeProvider theme={Theme}>
            <CssBaseline />
            {/* Context composer */}
            <Provider createStore={createStore}>
              <ContextProviderComposer
                contextProviders={[
                  <AuthProvider
                    key="auth"
                    isShowingLogin={isShowingLogin}
                    referCode={referCode}
                    forgetpasscode={forgetpasscode}
                    action={action}
                    tokenv1={t}
                    token={token}
                    redirectUrl={redirectUrl}
                    // initAccount={accountInfo}
                    initUser={user}
                  />,
                  <ProductContextProvider key="product" initUser={user} />,
                  <CartContextProvider key="cart" cartQuantity={cartQuantity} />,
                  <NotiContextProvider key="noti" initUser={user} />,
                  <SettingProvider key="setting" />,
                  <SearchProvider key="search" />,
                  <WishListProvider key="wishlist" />,
                  <TicketProvider key="ticket" />,
                  <PopupProvider key="popup" />,
                  // <Provider config={rollbarConfig} />,
                ]}
              >
                {/* Protect route */}
                <LoadingRoute>
                  <Clarity />
                  <InactiveCustomerGuard />
                  {/* popup chi tiết voucher dùng chung (/promo-codes, giỏ, trang SP); cần Auth + Cart */}
                  <VoucherDetailPopupProvider isMobile={!!pageProps?.isMobile}>
                    <Component {...pageProps} />
                  </VoucherDetailPopupProvider>
                  {/* TODO: FbMessenger  FEATURE-CHAT */}
                  {/* {pageProps.isMobile && isShowIconFBPage && pageProps?.isAuthenticated && <IconChat isAuthenticated={pageProps?.isAuthenticated} onClick={toggleChat} />} */}
                  {pathname !== '/conversations' && pathname !== '/lucky-wheel' && (
                    <SupportCenter
                      isShowIconFBPage={isShowIconFBPage}
                      isAuthenticated={pageProps?.isAuthenticated}
                      toggleChat={toggleChat}
                    />
                  )}
                  {/* {pageProps.isMobile && isShowIconFBPage && <IconChat isAuthenticated={pageProps?.isAuthenticated} onClick={toggleChat} />} */}
                  {/* ChatThuocSi comp gồm FB mess, Internal Chat, Chat setting */}
                  {/* add key để reload lại chat khi login */}
                  {/* {!pageProps.isMobile && <ChatThuocSi key={pageProps?.isAuthenticated || null} />} */}
                  {pathname !== '/conversations' && <ScrollToTop {...router} />}
                  {/* {!pageProps.isMobile && <ContactInfoFixed />} */}
                  <ToastContainer
                    limit={2}
                    pauseOnHover={false}
                    hideProgressBar
                    autoClose={2000}
                    closeOnClick
                  />
                </LoadingRoute>
              </ContextProviderComposer>
            </Provider>
          </MuiThemeProvider>
        </StyledTheme>
      </StylesProvider>
      {/* Khởi tạo InsiderQueue TRƯỚC khi Insider Tag script được tải.
          Web SDK dùng queue như buffer: mọi push() xảy ra trước khi script load
          sẽ được Insider Tag tự động đọc và xử lý khi khởi động. */}
      <Script id="insider-queue-init" strategy="beforeInteractive">
        window.InsiderQueue = window.InsiderQueue || [];
      </Script>
      {INSIDER_ID && INSIDER_SCRIPT_DOMAIN && (
        <Script
          id="insider-tag"
          src={`//${INSIDER_SCRIPT_DOMAIN}/ins.js?id=${INSIDER_ID}`}
          strategy="afterInteractive"
        />
      )}

      {ENV === 'prd' && isMobileV2 && isTrackingMobileV2 && (
        <>
          <Script
            strategy="lazyOnload"
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID_V2}&l=dataLayerGAV2`}
          />
          <Script strategy="lazyOnload">
            {`
                    window.dataLayerGAV2 = window.dataLayerGAV2 || [];
                    function gtagGAV2(){dataLayerGAV2.push(arguments);}
                    gtagGAV2('js', new Date());
                    gtagGAV2('config', '${GA_TRACKING_ID_V2}', {
                    page_path: window.location.pathname,
                    });
                `}
          </Script>
        </>
      )}
    </>
  );
};

// MyApp.getInitialProps = async (appContext) => ({ ...(await App.getInitialProps(appContext)) });

MyApp.getInitialProps = async (appContext) => {
  const time = +new Date();
  const appProps = await App.getInitialProps(appContext);
  let host = '';
  try {
    host = appContext.ctx.req.headers.host || '';
  } catch (error) {
    host = "can't detect host";
  }

  let isMobile = '';
  try {
    const UA = appContext.ctx.req.headers['user-agent'];
    isMobile = Boolean(UA.match(MOBILE));
  } catch (error) {
    isMobile = `can not detect device - ${error}`;
  }

  return {
    ...appProps,
    host,
    buildId: publicRuntimeConfig.buildId,
    timeAPP: +new Date() - time,
    pageProps: {
      isMobile,
    },
  };
};

export default appWithTranslation(MyApp, nextI18nConfig);
